import React, { useEffect, useState } from 'react';
import { Grid, Skeleton, Alert, Link } from '@mui/material';
import Chart from 'react-apexcharts';
import axios from 'src/utils/axios';
import { useTheme } from '@mui/material/styles';
const today = new Date();
const lastYear = today.getFullYear() - 1
const thisYear = today.getFullYear()

//today format string 27 Kasım 2023 tr
//lastYear format string 27 Kasım 2023 tr
const todayString = today.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
const lastYearString = new Date(lastYear, today.getMonth(), today.getDate()).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
const defaultData = [
    {
        "ToplamHizmetSüresi": 0,
        "ToplamFis": 0,
        "HizmetTipi": "Arıza",
        "Year": lastYear,
        "Date": lastYearString
    },
    {
        "ToplamHizmetSüresi": 0,
        "ToplamFis": 0,
        "HizmetTipi": "Montaj",
        "Year": lastYear,
        "Date": lastYearString
    },
    {
        "ToplamHizmetSüresi": 0,
        "ToplamFis": 0,
        "HizmetTipi": "Nakliye",
        "Year": lastYear,
        "Date": lastYearString
    },
    {
        "ToplamHizmetSüresi": 0,
        "ToplamFis": 0,
        "HizmetTipi": "Arıza",
        "Year": thisYear,
        "Date": todayString
    },
    {
        "ToplamHizmetSüresi": 0,
        "ToplamFis": 0,
        "HizmetTipi": "Montaj",
        "Year": thisYear,
        "Date": todayString
    },
    {
        "ToplamHizmetSüresi": 0,
        "ToplamFis": 0,
        "HizmetTipi": "Nakliye",
        "Year": thisYear,
        "Date": todayString
    }
];

const ServiceAverageTime = ({ ServiceShopId, EmployeeRole }) => {
    const [data, setData] = useState(defaultData);
    const [loading, setLoading] = useState(true);
    const theme = useTheme();


    useEffect(() => {
        axios.get(`GetServiceAverageTime/${ServiceShopId}`).then((response) => {
            if (response) {
                if (response.data.length > 0) {
                    setData(response.data);
                }
                else {
                    setData(defaultData);
                }
            }
            setLoading(false);
        });
    }, [ServiceShopId]);

    console.log(EmployeeRole)

    const ServiceAverageTimeData = {
        series: [
            {
                name: 'Montaj Hizmet Süresi',
                data: data
                    .filter(item => item.HizmetTipi === "Montaj")
                    .map(item => (item.ToplamHizmetSüresi / item.ToplamFis).toFixed(1))
            },
            {
                name: 'Nakliye Hizmet Süresi',
                data: data
                    .filter(item => item.HizmetTipi === "Nakliye")
                    .map(item => (item.ToplamHizmetSüresi / item.ToplamFis).toFixed(1))
            },
            {
                name: 'Arıza Hizmet Süresi',
                data: data
                    .filter(item => item.HizmetTipi === "Arıza")
                    .map(item => (item.ToplamHizmetSüresi / item.ToplamFis).toFixed(1))
            }
        ],
        options: {
            chart: {
                type: 'bar',
                stacked: false,
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }
            },
            xaxis: {
                categories: [
                    ...new Map(data.map((item) => [`01 Ocak ${item.Year}`, '-', `${item.Date}`])
                        .map(subArray => [JSON.stringify(subArray), subArray]))
                        .values()
                ],
            },
            yaxis: {
                title: {
                    text: 'Ortalama Hizmet Süresi (Gün)'
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                }
            },
            colors: ['#008FFB', '#00E396', '#FF4560'], // Montaj, Nakliye, Arıza renkleri
            title: {
                text: 'Yıllık Ortalama Hizmet Süreleri'
            },
            legend: {
                position: 'bottom'
            },
            noData: {
                text: "Veriler yükleniyor lütfen bekleyiniz...",
                align: 'center',
                verticalAlign: 'middle',
                offsetX: 0,
                offsetY: 0,
                style: {
                    color: '#FF9800',
                    fontSize: '25px',
                }
            }

        }
    };

    const calculateIncrease = (seriesData) => {
        if (seriesData.length > 1) {
            return (((seriesData[1] - seriesData[0]) / seriesData[0]) * 100).toFixed(2);
        }
        return 0;
    };

    const getRadialBarTitle = (type, value) => {
        if (value >= 0) {
            return `${type} Artış Oranı`;
        } else {
            return `${type} Azalış Oranı`;
        }
    };

    const getRadialBarColor = (value) => {
        if (value >= 0) {
            return '#d32f2f';
        } else {
            return '#2e7d32';
        }
    };


    const serviceMontageAverageTimeIncrease = calculateIncrease(ServiceAverageTimeData.series[0].data);
    const serviceTransportAverageTimeIncrease = calculateIncrease(ServiceAverageTimeData.series[1].data);
    const serviceFaultAverageTimeIncrease = calculateIncrease(ServiceAverageTimeData.series[2].data);


    const radialBarOptions = (title, series, color) => ({
        series: [Math.abs(series)],
        chart: {
            height: 350,
            type: 'radialBar',
            offsetY: -10
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                dataLabels: {
                    name: {
                        fontSize: '12px', // Font boyutunu küçült
                        color: color,
                        offsetY: 80, // Y konumunu ayarla
                        formatter: function (val) {
                            // Kısa bir etiket formatı kullan
                            return val;
                        }
                    },
                    value: {
                        offsetY: 100, // Y konumunu ayarla
                        fontSize: '18px', // Font boyutunu küçült
                        formatter: function (val) {
                            return val + "%";
                        }
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                shadeIntensity: 0.15,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 50, 65, 91]
            },
        },
        stroke: {
            dashArray: 4
        },
        labels: [title],
        colors: [color],
    });

    return (
        <div>
            <Grid container spacing={1}>
                <Grid size={12}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={350} />
                    ) : (
                        <Chart
                            options={ServiceAverageTimeData.options}
                            series={ServiceAverageTimeData.series}
                            type="bar"
                            height={350}
                        />
                    )}
                </Grid>
                <Grid size={4}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={280} />
                    ) : (
                        <Chart
                            options={radialBarOptions(getRadialBarTitle('Montaj Süresi', serviceMontageAverageTimeIncrease), serviceMontageAverageTimeIncrease, getRadialBarColor(serviceMontageAverageTimeIncrease))}
                            series={[serviceMontageAverageTimeIncrease]}
                            type="radialBar"
                            height={280}
                        />
                    )}
                </Grid>
                <Grid size={4}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={280} />
                    ) : (
                        <Chart
                            options={radialBarOptions(getRadialBarTitle('Nakliye Süresi', serviceTransportAverageTimeIncrease), serviceTransportAverageTimeIncrease, getRadialBarColor(serviceTransportAverageTimeIncrease))}
                            series={[serviceTransportAverageTimeIncrease]}
                            type="radialBar"
                            height={280}
                        />
                    )}
                </Grid>
                <Grid size={4}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={280} width={'100%'} />
                    ) : (
                        <Chart
                            options={radialBarOptions(getRadialBarTitle('Arıza Süresi', serviceFaultAverageTimeIncrease), serviceFaultAverageTimeIncrease, getRadialBarColor(serviceFaultAverageTimeIncrease))}
                            series={[serviceFaultAverageTimeIncrease]}
                            type="radialBar"
                            height={280}
                        />
                    )}
                </Grid>
                <Grid size={12}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={100} />
                    ) : (
                        (EmployeeRole === 1 || EmployeeRole === 2) && (
                            <Alert
                                variant="outlined"
                                severity="info"
                                sx={{
                                    borderColor: theme.palette.info.dark,
                                    fontSize: '12px',
                                    fontFamily: 'Helvetica, Arial, sans-serif'
                                }}
                            >
                                Detaylı kırılımlarda görüntülemek için Atlas dashboardlardan faydalanabilirsiniz.
                                <br />
                                <Link
                                    href="https://atlas.beko.com/okta/sense/app/48e84271-abbf-4c9e-8241-2782a507dbec/sheet/86480244-320f-4849-80ae-ba4522fc64e5/state/analysis"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    İlgili Atlas dashboardundan faydalanmak için tıklayınız.
                                </Link>
                            </Alert>
                        )
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

export default ServiceAverageTime;
